module.exports = __webpack_public_path__ + "static/media/star.5f34fd4f.svg";